module.exports = __webpack_public_path__ + "img/gimmelwald.d1a35cb4.jpg";